import type { Song } from "./types";

const getSongDuplicateKey = (song: Song) =>
  `${song.title.trim()}---${song.artist.trim()}`;

export default getSongDuplicateKey;
